{
  const buttons = document.querySelectorAll('[data-scroll-to-apps]');  
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      setTimeout(() => document.location.href='/apk/omnio.apk', 1000);
    });
  });
}